import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator, enableIndexedDbPersistence } from 'firebase/firestore';

// استخدام Environment Variables مع fallback للقيم الافتراضية (للتوافق مع الإصدارات القديمة)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBdDeu_lHE1aRszFHe3F8kV4daLYuTNYL8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "plan-fd4d9.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://plan-fd4d9-default-rtdb.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "plan-fd4d9",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "plan-fd4d9.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "934269315901",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:934269315901:web:90a9cf5188bcf8fb5d7354",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-012BT7YGEC"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// تفعيل Offline Persistence لتحسين الأداء والاتصال
// هذا يسمح لـ Firestore بالعمل في وضع offline ويحسن الأداء
if (typeof window !== 'undefined') {
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled in one tab at a time.
      console.warn('Firestore persistence failed: Multiple tabs may be open');
    } else if (err.code === 'unimplemented') {
      // The current browser does not support all of the features required for persistence
      console.warn('Firestore persistence not available in this browser');
    } else {
      console.warn('Firestore persistence error:', err);
    }
  });
}

